//Scripting for image copyright toggling
(function($){
	$('figure.wp-block-image figcaption, figure.wp-block-media-text__media figcaption, .blocks-gallery-grid .blocks-gallery-item figcaption').click(function(e) {
		$(this).toggleClass('open');
	});

})(jQuery);
